import { Container, Row, Col, Image, Carousel } from 'react-bootstrap';
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import './About.css';

/**
 * @typedef {Object} SliderImage
 * @property {number} id
 * @property {string} url
 */

export default function About() {
    const images = /** @type {SliderImage[]} */ ([
        { id: 1, url: 'https://boac-website.s3.eu-central-1.amazonaws.com/about_slider_img_1.jpg' },
        { id: 2, url: 'https://boac-website.s3.eu-central-1.amazonaws.com/about_slider_img_2.jpg' },
        { id: 3, url: 'https://boac-website.s3.eu-central-1.amazonaws.com/about_slider_img_3.jpg' },
        { id: 4, url: 'https://boac-website.s3.eu-central-1.amazonaws.com/about_slider_img_4.jpg' }
    ]);

    return (
        <>
            <Container className='about-container'>
                <Row>
                    <Col className='about-first-text'>
                        <h1>BOAC Soft Serve’ü Daha Yakından Tanıyın!</h1>
                        <p>BOAC Soft Serve olarak kiosk konseptli dükkanlarımızla müşterilerimize en kolay ve en pratik şekilde ulaşıyoruz. “We serve, you deserve" sloganıyla yola çıktığımız markamızda, lezzetli dondurma ve tatlılarla dolu bir dünyaya kapı aralıyoruz. Müşterilerimize en taze ve kaliteli malzemelerle hazırladığımız özel tariflerimizle unutulmaz bir tatlı deneyimi sunuyoruz. Her bir ürünümüzde özgünlük ve lezzetin izlerini taşıyor, müşterilerimize damaklarında unutulmaz bir tat bırakmayı amaçlıyoruz.</p>
                    </Col>
                </Row>
                <Row>
                    <Col className='about-bg-col'>
                        <Image
                            className="about-bg-img-1"
                            src="https://boac-website.s3.eu-central-1.amazonaws.com/about_bg_1.png" />
                        <div className='about-bg-text-1'>
                            <h1>Vizyonumuz</h1>
                            <p>BOAC Soft Serve olarak vizyonumuz, müşterilerimize en kaliteli ve yenilikçi tatlı deneyimini sunmaktır. Yaratıcı ve lezzetli ürünlerimizle her anınıza tat katmak, öncelikli hedefimizdir.</p>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col className='about-bg-col'>
                        <Image
                            className="about-bg-img-2"
                            src="https://boac-website.s3.eu-central-1.amazonaws.com/about_bg_2.png" />
                        <div className='about-bg-text-2'>
                            <h1>Misyonumuz</h1>
                            <p>Misyonumuz, herkesin kolayca erişebileceği, sağlıklı ve lezzetli bir tatlı deneyimi sunmaktır. Müşterilerimizin memnuniyeti ve damak zevklerine hitap etmek için sürekli olarak kendimizi geliştiriyor ve inovatif yaklaşımlarımızla sektörde öncü olmayı hedefliyoruz.</p>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col className='about-second-text'>
                        <h1>BOAC Soft Serve</h1>
                        <h2>Lezzetin Yeni Tanımı</h2>
                    </Col>
                </Row>
                <Row className='about-no-row'>
                    <Col xs={3} md={3} lg={3}>
                        <Image
                            className="about-no-img"
                            src="https://boac-website.s3.eu-central-1.amazonaws.com/about_no_1.png" />
                    </Col>
                    <Col className='about-no-text' xs={9} md={9} lg={9}>
                        <h3>Dondurma ve Yoğurt Severlerin Buluşma Noktası:</h3>
                        <p>Arkadaşlarınızla veya ailenizle tatlı bir kaçamak yapmanın en keyifli adresi. Sofistike lezzetleri ve çeşitli sunum seçenekleriyle, leziz atıştırmalıklarınızı paylaşmanın tadını çıkarın.</p>
                    </Col>
                </Row>
                <Row>
                    <Col xs={3} md={3} lg={3}>
                        <Image
                            className="about-no-img"
                            src="https://boac-website.s3.eu-central-1.amazonaws.com/about_no_2.png" />
                    </Col>
                    <Col className='about-no-text' xs={9} md={9} lg={9}>
                        <h3>Sağlıklı Atıştırmalıkların Yeni Adresi:</h3>
                        <p>Sağlıklı atıştırmalık arayanlar için taze meyvelerle hazırlanan ve birbirinden lezzetli yoğurt seçenekleri sunan BOAC Soft Serve besleyici tatların buluşma noktası.</p>
                    </Col>
                </Row>
                <Row>
                    <Col xs={3} md={3} lg={3}>
                        <Image
                            className="about-no-img"
                            src="https://boac-website.s3.eu-central-1.amazonaws.com/about_no_3.png" />
                    </Col>
                    <Col className='about-no-text' xs={9} md={9} lg={9}>
                        <h3>Kusursuz Lezzet Deneyimi:</h3>
                        <p>BOAC Soft Serve'in pürüzsüz dokusu, günlük meyveleri ve el yapımı lezzetleri, damağınızı şımartırken kalbinizi de fethediyor, her kaşıkta farklı bir mutluluk yaşatıyor.</p>
                    </Col>
                </Row>
                <Row>
                    <Col xs={3} md={3} lg={3}>
                        <Image
                            className="about-no-img"
                            src="https://boac-website.s3.eu-central-1.amazonaws.com/about_no_4.png" />
                    </Col>
                    <Col className='about-no-text' xs={9} md={9} lg={9}>
                        <h3>Her An Keyifli Bir Kaçamak:</h3>
                        <p>Tatlı bir kaçamak yapmak istediğinizde BOAC Soft Serve haftanın 7 günü hizmetinizdedir.</p>
                    </Col>
                </Row>
            </Container>
            <div className='about-bg-full-col'>
                <Image
                    className="about-bg-full-img"
                    src="https://boac-website.s3.eu-central-1.amazonaws.com/about_bg_3.png" />
                <h3 className='about-bg-full-text'>BOAC Soft Serve olarak, lezzetin sınırlarını zorlayan bir marka olarak yolculuğumuza devam ediyoruz. Siz de bizimle birlikte bu lezzet dolu maceraya katılarak, tatlı tutkunluğunuzun yeni ve sağlıklı adresini keşfedin!</h3>
            </div>
            <div style={{ margin: '0', padding: '0' }}>
                <Carousel
                    indicators={false}
                    nextIcon={<MdChevronRight className='carousel-right-icon' size={100} />}
                    prevIcon={<MdChevronLeft className='carousel-left-icon' size={100} />}>
                    {images.map((item) => (
                        <Carousel.Item key={item.id}>
                            <div>
                                <Image
                                    className="d-block w-100"
                                    style={{ objectFit: 'cover' }}
                                    src={item.url} />
                            </div>
                        </Carousel.Item>
                    ))}
                </Carousel>
            </div>
        </>
    );
}
